import { render } from "./Data.vue?vue&type=template&id=3cb38f82"
const script = {}
script.render = render

export default script